import { render, staticRenderFns } from "./ArticleView.vue?vue&type=template&id=5b81dccc&scoped=true"
import script from "./ArticleView.vue?vue&type=script&lang=js"
export * from "./ArticleView.vue?vue&type=script&lang=js"
import style0 from "./ArticleView.vue?vue&type=style&index=0&id=5b81dccc&prod&lang=scss"
import style1 from "./ArticleView.vue?vue&type=style&index=1&id=5b81dccc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b81dccc",
  null
  
)

export default component.exports